import { NoSSR } from '@utils/react';
import { WordPrintTask } from './atom.task.js';
import { useBacklinkUrl } from './hook.backlink-url.js';
import { header, heading, backlink } from './organism.print.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function WordPrintLayoutContent(props) {
  const backlink$1 = useBacklinkUrl(props.component.entryKey);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: header,
      children: [/*#__PURE__*/jsx("h1", {
        className: heading,
        children: props.component.envelope.Title
      }), /*#__PURE__*/jsx(NoSSR, {
        children: backlink$1 && /*#__PURE__*/jsxs("span", {
          className: backlink,
          children: [/*#__PURE__*/jsx("b", {
            children: "Find opgaven her:"
          }), " ", /*#__PURE__*/jsx("a", {
            href: backlink$1.toString(),
            tabIndex: -1,
            children: backlink$1.toString()
          })]
        })
      })]
    }), props.component.data.tasks.filter(task => task.inputs.length > 0).map(task => /*#__PURE__*/jsx(WordPrintTask, {
      task: task,
      component: props.component
    }, task.id))]
  });
}

export { WordPrintLayoutContent };
//# sourceMappingURL=organism.print.js.map
